import { TextField, Box, InputLabel } from "@material-ui/core";
import { t } from "i18next";
import React from "react";
import Flex from "components/grid/Flex";
import utils from 'utils/Utils';

const Range = (props) => {
    const { config, rule, idx, handleUpdateRule } = props;
    const handleUpdate = (from, to) => {
        handleUpdateRule(idx, {
            ...rule.properties,
            value: from || to ? {
                type: rule.properties.value.type || "range",
                from: from || undefined,
                to: to || undefined,
            } : {},
        });
    }
    return (
        <Box key={idx} display="flex" flexDirection="row" alignItems="center" style={{ gap: "10px" }}>
            <TextField
                size="small"
                style={{ width: config.width ? config.width + "px" : undefined }}
                placeholder={t("global.from")}
                value={rule.properties.value.from}
                onChange={(e) =>
                    handleUpdate(
                            utils.isNumeric(e.target.value) && !config?.isDate ? Number(e.target.value) : e.target.value,
                            rule.properties.value.to
                    )
                }
            ></TextField>
            <span style={{ alignSelf: "center", fontWeight: "bold", fontSize: "1.1em" }}>-</span>
            <TextField
                size="small"
                style={{ width: config.width ? config.width + "px" : undefined }}
                placeholder={t("global.to")}
                value={rule.properties.value.to}
                onChange={(e) =>
                        handleUpdate(
                                rule.properties.value.from,
                                utils.isNumeric(e.target.value) && !config?.isDate ? Number(e.target.value) : e.target.value
                        )
                }
            ></TextField>
        </Box>
    );
};

export const RangeRenderer = (props) =>
    props.config?.label && props.config?.nestedComponent ? (
        <Flex item container column style={{ marginTop: -17 }}>
            <InputLabel shrink>{props.config?.label}</InputLabel>
            <Range {...props} />
        </Flex>
    ) : (
        <Range {...props} />
    );
